import { H2, H3, P1 } from '../../../styles/FontStyles';
import { Main, Section7Wrapper } from '../Home.styled';

import image from '../../../assets/images/sec7Image.png';
import { colors, lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';
import { AnimatedDiv } from 'components/Animation/Animation';

const textStyle = {
  color: colors.primary,
  fontWeight: 'bold',
};

export const Section7 = () => {
  const Title = () => {
    return (
      <H2 mb='24' centerSM color={lightTheme.white}>
        Meet the Founder
      </H2>
    );
  };

  return (
    <Section7Wrapper id='section7'>
      <Main>
        <AnimatedDiv $flex $center $columnSM $gap='50px' $gapSM='24px'>
          <Div $width='40%' $widthSM='100%'>
            <Div $mobile>
              <Title />
            </Div>
            <Img src={image} width='100%' alt='section4' />
          </Div>
          <Div $width='60%' $widthSM='100%'>
            <Div $desktop>
              <Title />
            </Div>
            <H3 mb='5' centerSM color={lightTheme.primary}>
              <b>Jan Lauryssen</b>
            </H3>
            <P1 mb='0' centerSM color={lightTheme.white}>
              Founder- United One
            </P1>
            <Div $flex $column $gap='10px'>
              <ul style={{ color: lightTheme.primary }}>
                <li>
                  <P1 mb='0' color={lightTheme.white}>
                    <span style={textStyle}>Founder of United One</span>, with a
                    legal presence in Dubai
                  </P1>
                </li>
                <li>
                  <P1 mb='0' color={lightTheme.white}>
                    Accomplished Belgian entrepreneur{' '}
                    <span style={textStyle}>
                      with 14+ years leading successful businesses and teams
                    </span>
                  </P1>
                  <li>
                    <P1 mb='0' color={lightTheme.white}>
                      Proven track record managing 145+{' '}
                      <span style={textStyle}>
                        employees across multiple companies
                      </span>
                    </P1>
                  </li>
                  <li>
                    <P1 mb='0' color={lightTheme.white}>
                      Dedicated to building high-quality, ethical partnerships
                      and sustainable growth
                    </P1>
                  </li>
                  <li>
                    <P1 mb='0' color={lightTheme.white}>
                      Passionate about teamwork, innovation, and long-term
                      collaboration
                    </P1>
                  </li>
                </li>
              </ul>
            </Div>
          </Div>
        </AnimatedDiv>
      </Main>
    </Section7Wrapper>
  );
};
